// material ui icons
import SensorsIcon from '@mui/icons-material/Sensors';

// material ui
import { Chip } from '@mui/material';
import type { ChipProps } from '@mui/material';

interface SensorTagProps {
  label: string | number;
  sx?: ChipProps['sx'];
}

const SensorTag = ({ label, sx }: SensorTagProps) => {
  return (
    <Chip
      icon={<SensorsIcon fontSize="small" />}
      label={label}
      size="small"
      sx={[
        {
          borderRadius: 1,
          backgroundColor: 'info.main',
          color: '#fff',
          '& .MuiChip-icon': { color: '#fff' },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
};

export default SensorTag;
